module.exports = __webpack_public_path__ + "static/media/no-data-icon.10ad40ab.svg";